import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  colors
} from "@material-ui/core";
import AudioAnalyzerIcon from '@material-ui/icons/Audiotrack';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import 'date-fns';
import React from 'react';
import AudioAnalyzer from 'src/components/AudioAnalyzer';
import Header from 'src/components/Header';
import Page from 'src/components/Page';

const useStyles = makeStyles((theme) => ({
  success: {
    backgroundColor: colors.green[600],
    color: theme.palette.common.white
  },
  info: {
    backgroundColor: colors.lightBlue[600],
    color: theme.palette.common.white
  },
  warning: {
    backgroundColor: colors.yellow[900],
    color: theme.palette.common.white
  },
  error: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.error.contrastText
  },
  root: {
    paddingTop: theme.spacing(3),
    flexGrow: 1
  },
  TableCellHeader: {
    backgroundColor: '#eee',
    fontWeight: 'bold',
    width: '5%',
    align: 'left'
  },
  cardHeader: {
    flexGrow: 1
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  searchDF: {
    flexGrow: 1,
    height: 42,
    padding: theme.spacing(0, 2),
    display: 'flex',
    alignItems: 'center'
  },
  searchIconDF: {
    marginRight: theme.spacing(0),
    color: theme.palette.icon
  },
  searchInputDF: {
    flexGrow: 1
  },
  fieldsGaranti: {
    margin: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1)
    }
  },
  contentGaranti: {
    minHeight: 430,
  },
  submitButtonAeee: {
    marginTop: theme.spacing(2),
    width: '100%'
  },
}));


function DefectSoundRecognition({ className }) {
  const classes = useStyles();
  const [AudioAnalyzerOpen, setAudioAnalyzerOpen] = React.useState(false);
  const handleAudioAnalyzerClose = () => {
    setAudioAnalyzerOpen(false);
  };


  return (
    <Page className={classes.root} title="Ek Garanti Satış Takip">
      <Container maxWidth="lg">
        <Header />
        <Card
          className={clsx(classes.cardHeader, className)}
        >
          <CardHeader title="Sesten Arıza Tanıma" />
          <Divider />
          <CardContent>
            <Button
              variant="contained"
              color="secondary"
              fullWidth
              endIcon={<AudioAnalyzerIcon>Close</AudioAnalyzerIcon>}
              onClick={() => setAudioAnalyzerOpen(true)}>
              Sesten Arıza Tanıma Başlat
            </Button>
          </CardContent>
          <Divider />
        </Card>
      </Container>
      <Dialog
        open={AudioAnalyzerOpen}
        onClose={handleAudioAnalyzerClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">
          {"Sesten Arıza Analizi"}
        </DialogTitle>
        <DialogContent>
          <AudioAnalyzer />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleAudioAnalyzerClose} color="primary">
            Tamam
          </Button>
        </DialogActions>
      </Dialog>

    </Page >
  );
}

export default DefectSoundRecognition;
